<template>
<div>
    <base-header v-once pageName="고객통합하기" :popup="true"></base-header>
    
    <section id="wrap">
        <div class="myCus-intg">
            <p>동일한 전화번호로 등록된 가망/계약고객을<br/>하나의 계약고객으로 통합하세요.</p>

            <span class="radio" >
                <input type="radio" name="" id="all" @click="chkRadioAll()">
                <label for="all">{{tot}}건</label>
            </span>
            <ul v-for="(item , index) in list" v-bind:key="index">
                <li>
                    <span class="radio" @click="chkRadio(index)">
                        <input type="radio" v-bind:name="'radio'+index" v-bind:id="'radio'+index" v-bind:value="item.kwkkey" v-model="item.chkKwkkey">
                        <label v-bind:for="'radio'+index">{{item.kwcddd}}-{{item.kwctl1}}-{{item.kwctl2}}</label>
                    </span>
                    <div>                            
                        <template v-if="item.inpath === 'G'">
                          <em class="mom">하이맘</em>
                        </template>
                        <template v-else-if="item.inpath === 'K'">
                          <em class="exp">체험</em>
                        </template>
                        <template v-else>
                          <em class="prospect">가망</em>
                        </template>                        
                        <span>{{item.custname}}</span>
                        <i>{{item.kwcddd}}-{{item.kwctl1}}-{{item.kwctl2}}</i>
                    </div>
                    <div>                            
                        <em class="contract">계약</em>
                        <span>{{item.kwcnam}}</span>
                        <i>{{item.kwcddd}}-{{item.kwctl1}}-{{item.kwctl2}}</i>
                    </div>
                </li>
            </ul>
        </div>

        <infinite-loading @infinite="infiniteHandler" spinner="waveDots" ref="InfiniteLoading">
          <div slot="no-more"></div>
          <div slot="no-results">조회된 고객이 없습니다.</div>
        </infinite-loading> 
    </section>

        <div class="btnWrap" v-if="tot != 0">
          <button type="button" class="white" @click="onCancel()">취소</button>
          <button type="button" class="red" @click="saveCustIntegration()">통합하기</button>
        </div>
  </div>
</template>

<script>
import InfiniteLoading from "vue-infinite-loading";

export default {
  name: "CustIntegrationList",
  components: {
    InfiniteLoading,
    // CustIntegrationList
  },
  data() {
      return{
          
          active : null,
          list:[],
          tot:0,
          offset: 0,     //현재 가지고있는 갯수
          size : 100    //한번에 가져오는 수
      };
  },

  methods: {
    infiniteHandler : function($state){
			console.log('SCROLL')
      var that = this;
      var parameters = {
        offset: this.offset,
        size: this.size
      }; 
      this.$api.myCstmr
        .custIntegrationList(parameters)
        .then(function(data) {
          that.tot = data.totCnt;  // API에서 가져온 총 카운트
          var list = data.list;   //API에서 가져온 리스트
          if (list.length) {
            that.list = that.list.concat(list);
            $state.loaded();
            that.offset += that.size;

            if (list.length < that.size) {
              $state.complete();
            }
          } else {
            $state.complete();
          }
        })
        .catch(function(error) {
          alert(error.rtMsg);
          console.log(error);
        });
    },

    chkRadioAll :function() {
      for(var i = 0 ; i < this.list.length ; i ++) {
        this.list[i].chkKwkkey = this.list[i].kwkkey ;
        this.list[i].insertFlag = "Y";
      }
    },

    onCancel() {
      if(confirm('고객통합을 취소 하시겠습니까?')) {
        this.$router.go(this.$router.currentRoute);
      }
    },
    chkRadio :function(index ) {
      this.list[index].insertFlag = "Y";
    },

    saveCustIntegration : function(){
      var that = this;
      var insertList = that.list.filter(function (element) { return element.insertFlag ==  "Y"});

    if(confirm("선택한 고객을 통합 하시겠습니까?")){

    var jsonString = JSON.stringify(insertList);
    console.log(insertList);
    console.log(jsonString);

    var param = {};
    param.jsonString = jsonString;

      this.$api.myCstmr
      .saveCustIntegration(param)
      .then(function(data) {

        if(data && data > 0){
          alert("고객통합을 완료했습니다.");
          that.totalCnt = 0
          that.offset = 0
          that.size = 100
          that.list = []
          that.$refs.InfiniteLoading.stateChanger.reset(); 
          console.log("CstIntegration.vue <api.saveCustIntegration.response>",data);
        }else{
          alert("고객통합에 실패했습니다.");
        }

      })
      .catch(function(error) {
        alert(error.rtMsg);
      });
      
      
     }
		}

  }
};
</script>
